module.exports = __webpack_public_path__ + "images/sales_contact_suggestion/appeal_background_da179a25357c2ff1caf8243927ed2b60.png";